package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Insert
import androidx.room3.OnConflictStrategy
import androidx.room3.Query
import androidx.room3.RawQuery
import androidx.room3.RoomRawQuery
import com.xtream.data_kmp.WatchedIntermediateSeriesStream
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingTvShow
import com.xtream.data_kmp.dto.seriesStreamsTable
import com.xtream.data_kmp.seriesFavoritesTable
import com.xtream.data_kmp.watchedSeriesStreamsTable
import kotlinx.coroutines.flow.Flow
enum class SeriesSortBy {
    DEFAULT,
    NAME_ASC,
    NAME_DESC,
    LAST_ADDED,
    RATING,
    NEWEST
}


@Dao
abstract class SeriesStreamsDao:BaseRoomStreamsInterface<SeriesStream> {
    @Query("SELECT * FROM seriesStreamsTable WHERE streamId = :id LIMIT 1")
    abstract  suspend fun getStreamById(id: Int?): SeriesStream?

    @Query("SELECT * FROM ${seriesStreamsTable} ORDER BY lastModified DESC LIMIT 10")
   abstract override suspend fun recentlyAdded(): List<SeriesStream>

    @Query("SELECT * FROM ${seriesStreamsTable} ORDER BY lastModified DESC LIMIT :limit")
    abstract override fun recentlyAddedFlow(limit: Int): Flow<List<SeriesStream>>

    @Query("SELECT COUNT(*) FROM ${seriesStreamsTable} ORDER BY lastModified DESC LIMIT 10")
   abstract override fun getRecentlyAddedSize(): Flow<Long>

    @Query("SELECT * FROM ${seriesStreamsTable} ORDER BY lastModified DESC")
    abstract override fun allAsFlow(): Flow<List<SeriesStream>>

    @Query("SELECT * FROM ${seriesStreamsTable} "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +"ORDER BY lastModified DESC"
            +" LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsFlow(categoryId:Int?, nameQuery:String?, limit: Int?, offset: Int?): Flow<List<SeriesStream>>
    @Query("""
    SELECT * FROM seriesStreamsTable
    WHERE (:categoryId IS NULL OR categoryId = :categoryId)
    AND (:excludeIds IS NULL OR streamId NOT IN (:excludeIds))
    ORDER BY RANDOM() 
    LIMIT :limit
""")
    abstract fun getRecommendationsList(
        categoryId: Int?,
        limit: Int,
        excludeIds: List<Int?>? = null
    ): Flow<List<SeriesStream>>

    @Query("SELECT * FROM ${seriesStreamsTable} "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +"ORDER BY lastModified DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsFlow(categoryId:Int?, nameQuery:String?): Flow<List<SeriesStream>>
    @Query("""SELECT 
watchedSeriesStreamsTable.streamId AS watched_streamId, 
watchedSeriesStreamsTable.episodeId AS watched_episodeId, 
watchedSeriesStreamsTable.videoExtension AS watched_videoExtension, 
watchedSeriesStreamsTable.added AS watched_added, 
watchedSeriesStreamsTable.progress AS watched_progress, 
watchedSeriesStreamsTable.totalProgress AS watched_totalProgress, 
watchedSeriesStreamsTable.backdrop AS watched_backdrop, 
        seriesStreamsTable.*
         FROM ${seriesStreamsTable}
            INNER JOIN ${watchedSeriesStreamsTable} 
            ON seriesStreamsTable.streamId = ${watchedSeriesStreamsTable}.episodeId
           GROUP BY ${watchedSeriesStreamsTable}.episodeId ORDER BY ${watchedSeriesStreamsTable}.added DESC           
            """)
    abstract fun getWatchedStreamsAsIntermediateFlow(): Flow<List<WatchedIntermediateSeriesStream>>

    @Query("""SELECT 
                watchedSeriesStreamsTable.streamId AS watched_streamId, 
                watchedSeriesStreamsTable.episodeId AS watched_episodeId, 
                watchedSeriesStreamsTable.videoExtension AS watched_videoExtension, 
                watchedSeriesStreamsTable.added AS watched_added, 
                watchedSeriesStreamsTable.progress AS watched_progress, 
                watchedSeriesStreamsTable.totalProgress AS watched_totalProgress, 
                watchedSeriesStreamsTable.backdrop AS watched_backdrop, 
        seriesStreamsTable.*
         FROM ${seriesStreamsTable}
            INNER JOIN ${watchedSeriesStreamsTable} 
            ON seriesStreamsTable.streamId = ${watchedSeriesStreamsTable}.episodeId
           GROUP BY ${watchedSeriesStreamsTable}.episodeId ORDER BY ${watchedSeriesStreamsTable}.added DESC   LIMIT :limit            
            """)
    abstract suspend fun getWatchedStreamsAsIntermediate(limit: Int?): List<WatchedIntermediateSeriesStream>

    @Query("SELECT seriesStreamsTable.*, ${seriesFavoritesTable}.sortOrder AS  'num' " +
            " FROM ${seriesStreamsTable} " +
            "INNER JOIN ${seriesFavoritesTable} ON seriesStreamsTable.streamId = ${seriesFavoritesTable}.streamId " +
            "ORDER BY ${seriesFavoritesTable}.sortOrder ASC" +
            " LIMIT :limit")
    abstract override fun getFavoriteStreamsFlow( limit: Int?):  Flow<List<SeriesStream>>

 @Query("""
        SELECT * FROM ${seriesStreamsTable}
        ORDER BY lastModified DESC
        LIMIT :limit
    """)
 abstract override fun getRecentlyAddedFlow(limit: Int): Flow<List<SeriesStream>>


    @Query("""
        SELECT * FROM ${seriesStreamsTable}
        ORDER BY lastModified DESC
        LIMIT :limit
    """)
 abstract override fun getRecentlyAdded(limit: Int): PagingSource<Int, SeriesStream>

 @Query("""
        SELECT * FROM ${seriesStreamsTable}
        ORDER BY lastModified DESC
        LIMIT :limit
    """)
 abstract suspend fun getRecentlyAddedList(limit: Int): List<SeriesStream>

 @Query("""
        SELECT * FROM ${seriesStreamsTable}
        WHERE (:categoryId IS NULL OR categoryId = :categoryId)
        ORDER BY releaseDate DESC
        LIMIT :limit
    """)
 abstract override fun getRecommendations(categoryId:Int?,limit: Int): PagingSource<Int, SeriesStream>
    @Query("SELECT seriesStreamsTable.*, ${seriesFavoritesTable}.sortOrder AS  'num' " +
            " FROM ${seriesStreamsTable} " +
            "INNER JOIN ${seriesFavoritesTable} ON seriesStreamsTable.streamId = ${seriesFavoritesTable}.streamId " +
            "ORDER BY ${seriesFavoritesTable}.sortOrder ASC")
    abstract  override suspend fun getFavoriteStreams():  List<SeriesStream>
    @Query("SELECT seriesStreamsTable.*, ${seriesFavoritesTable}.sortOrder AS  'num' " +
            " FROM ${seriesStreamsTable} " +
            "INNER JOIN ${seriesFavoritesTable} ON seriesStreamsTable.streamId = ${seriesFavoritesTable}.streamId " +
            "ORDER BY ${seriesFavoritesTable}.sortOrder ASC" +
            " LIMIT :limit")
    abstract suspend  fun getFavoriteStreams(limit: Int?):  List<SeriesStream>

    @Query("SELECT * FROM ${seriesStreamsTable} "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +"ORDER BY lastModified DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(categoryId:Int?, nameQuery:String?): PagingSource<Int, SeriesStream>
    @Query("SELECT * FROM ${seriesStreamsTable} "
            +"WHERE (:categoryIds IS NULL OR categoryId IN (:categoryIds))"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +"ORDER BY lastModified DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(categoryIds: List<Int>?, nameQuery: String?): PagingSource<Int, SeriesStream>
    @RawQuery(observedEntities = [SeriesStream::class])
    abstract fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, SeriesStream>
    fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: SeriesSortBy,
        yearRange: IntRange? = null,
    ): PagingSource<Int, SeriesStream> {
        val orderClause = when (sortBy) {
            SeriesSortBy.DEFAULT    -> "CAST(lastModified AS INTEGER) DESC"
            SeriesSortBy.NAME_ASC   -> "name ASC"
            SeriesSortBy.NAME_DESC  -> "name DESC"
            SeriesSortBy.LAST_ADDED -> "CAST(lastModified AS INTEGER) DESC"
            SeriesSortBy.RATING     -> "CAST(rating AS REAL) DESC"
            SeriesSortBy.NEWEST     -> "releaseDate DESC"
        }

        val args = mutableListOf<Any>()
        val whereClause = buildString {
            append("WHERE 1=1 ")
            if (!categoryIds.isNullOrEmpty()) {
                val placeholders = categoryIds.joinToString(",") { "?" }
                append("AND categoryId IN ($placeholders) ")
                args.addAll(categoryIds)
            }
            if (!nameQuery.isNullOrEmpty()) {
                append("AND name LIKE ? ")
                args.add("%$nameQuery%")
            }
            if (yearRange != null) {
                append("AND CAST(lastModified AS INTEGER) BETWEEN ? AND ? ")
                args.add(yearRange.first)
                args.add(yearRange.last)
            }
        }

        val sql = "SELECT * FROM $seriesStreamsTable $whereClause ORDER BY $orderClause"
println("SQL: $sql")
        return allAsPagingSourceRaw(RoomRawQuery(sql) { stmt ->
            args.forEachIndexed { index, arg ->
                when (arg) {
                    is Int    -> stmt.bindLong(index + 1, arg.toLong())
                    is String -> stmt.bindText(index + 1, arg)
                }
            }
        })
    }
    @Query("SELECT * FROM ${seriesStreamsTable} "

            +"ORDER BY lastModified DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(): PagingSource<Int, SeriesStream>



    @Query("SELECT seriesStreamsTable.*, ${seriesFavoritesTable}.sortOrder AS  'num' " +
            " FROM ${seriesStreamsTable} " +
            "INNER JOIN ${seriesFavoritesTable} ON seriesStreamsTable.streamId = ${seriesFavoritesTable}.streamId " +
            "ORDER BY ${seriesFavoritesTable}.sortOrder ASC")
   abstract override fun getPagedFavoriteStreams(): PagingSource<Int, SeriesStream>
    @Query("""
    SELECT * 
    FROM ${seriesStreamsTable} 
    INNER JOIN ${watchedSeriesStreamsTable} 
    ON seriesStreamsTable.streamId = ${watchedSeriesStreamsTable}.episodeId
    GROUP BY ${watchedSeriesStreamsTable}.episodeId
    ORDER BY ${watchedSeriesStreamsTable}.added DESC
""")

    abstract override fun getPagedWatchedStreams(): PagingSource<Int, SeriesStream>

    @Query("SELECT *  FROM ${seriesStreamsTable} " +
            "INNER JOIN ${watchedSeriesStreamsTable} ON seriesStreamsTable.streamId = ${watchedSeriesStreamsTable}.streamId"+
        " LIMIT :limit"

    )
    abstract override fun getWatchedStreamsFlow(limit: Int?): Flow<List<SeriesStream>>


    @Query("SELECT EXISTS (SELECT 1 FROM ${seriesStreamsTable} WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM ${seriesStreamsTable} WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>
    @Query("SELECT COUNT(*) FROM ${seriesStreamsTable} ")
    abstract override suspend fun getSize(): Long?
    @Query("SELECT COUNT(*) FROM ${seriesStreamsTable} "
            +" WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
    )
    abstract override suspend fun getSize(categoryId: Int?): Long?
     @Query("SELECT COUNT(*) FROM seriesStreamsTable"
             +" WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
     )
    abstract override fun getSizeAsFlow(categoryId: Int?):  Flow<Long?>
 @Query("DELETE FROM seriesStreamsTable")
 abstract override suspend fun deleteAll()

    @Query("SELECT * FROM ${seriesStreamsTable} "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +" ORDER BY lastModified DESC"
            +" LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/)
    abstract suspend fun all(categoryId:Int?, nameQuery:String?, limit: Int?, offset: Int?): List<SeriesStream>










    @Query("DELETE FROM TrendingTvShows")
    abstract suspend fun deleteTrending()

    @Insert(onConflict =  OnConflictStrategy.REPLACE)
    abstract suspend fun insertTrending(newList: List<TrendingTvShow>)

    @Query("""
SELECT 
    trending.streamIcon, 
    trending.name, 
    trending.adult, 
    trending.id, 
    trending.overview, 
    trending.backdrop,
    trending.popularity, 
    trending.releaseDate, 
    trending.voteAverage,
    tvShow.streamId
FROM TrendingTvShows trending 
JOIN seriesStreamsTable tvShow 
    ON tvShow.name LIKE trending.name
WHERE tvShow.streamIcon IS NOT NULL
GROUP BY tvShow.streamId
""")
    abstract fun trendingAsFlow(): Flow<List<TrendingTvShow>>


}